import { combineReducers } from "redux";
import AdminScreenReducer from "./admin";
import globalReducer from "./global";

export const rootReducer = combineReducers(
    {
        adminScreen : AdminScreenReducer,
        globalDtl: globalReducer,
    }
);